import {
  Block,
  Container,
  Content,
  Heading,
  Tile,
} from "react-bulma-components";

function ShuffleArray(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function Testimonials(props) {
  var quotations = ShuffleArray(
    props.quotes.guardian.concat(props.quotes.priory)
  );
  return (
    <Block mb="4">
      <Container>
        <Heading>Testimonials</Heading>
        <Tile kind="ancestor">
          <Tile>
            <Tile kind="parent" vertical="true">
              <Tile kind="child" className="is-secondary notification">
                <Content>"{quotations[0]}"</Content>
              </Tile>
              <Tile kind="child" className="is-secondary notification">
                <Content>"{quotations[1]}"</Content>
              </Tile>
            </Tile>
            <Tile kind="parent" vertical="true" >
              <Tile kind="child" className="is-secondary notification">
                <Content>"{quotations[2]}"</Content>
              </Tile>
            </Tile>
          </Tile>
        </Tile>
      </Container>
    </Block>
  );
}

export default Testimonials;

